<template>
<div>
    <v-card class="ma-2 pa-2" v-for="match in matchList" :key="match.MatchID">
        <v-card-title>
            <v-layout column>
                <v-flex xs12>{{match.StartTime.substr(0,4)}} {{match.DayOfWeek}} {{match.MatchNum}} {{match.TournamentName}}</v-flex>
                <v-flex xs12>{{match.HomeTeamCName}} VS {{match.AwayTeamCName}}</v-flex>
                <v-flex v-if="match.MatchStatus" xs12>{{match.MatchStatus}} > {{match.HomeFullScore}} : {{match.AwayFullScore}}</v-flex>
            </v-layout>
        </v-card-title>
        <v-divider class="mb-2" />
        <!-- {{match.TournamentName}} / {{match.StartDate}} -->
        <v-card-text>
            <v-layout v-if="match.HomeTournament">
                <v-flex xs4>{{match.HomeTournament.TeamCName}}</v-flex>
                <v-flex xs2>{{match.HomeTournament.Win}}</v-flex>
                <v-flex xs2>{{match.HomeTournament.Draw}}</v-flex>
                <v-flex xs2>{{match.HomeTournament.Lose}}</v-flex>
                <v-flex xs2>{{match.HomeTournament.Point}}</v-flex>
            </v-layout>

            <v-layout v-if="match.AwayTournament">
                <v-flex xs4>{{match.AwayTournament.TeamCName}}</v-flex>
                <v-flex xs2>{{match.AwayTournament.Win}}</v-flex>
                <v-flex xs2>{{match.AwayTournament.Draw}}</v-flex>
                <v-flex xs2>{{match.AwayTournament.Lose}}</v-flex>
                <v-flex xs2>{{match.AwayTournament.Point}}</v-flex>
            </v-layout>

            <v-layout v-if="match.NetTournament">
                <v-flex xs4>{{'Net'}}</v-flex>
                <v-flex xs2>{{match.NetTournament.Win}}</v-flex>
                <v-flex xs2>{{match.NetTournament.Draw}}</v-flex>
                <v-flex xs2>{{match.NetTournament.Lose}}</v-flex>
                <v-flex xs2>{{match.NetTournament.Point}}</v-flex>
            </v-layout>

            <v-layout v-if="match.PreTournament">
                <v-flex xs4>{{'Pre'}}</v-flex>
                <v-flex xs2>{{match.PreTournament.Win}}</v-flex>
                <v-flex xs2>{{match.PreTournament.Draw}}</v-flex>
                <v-flex xs2>{{match.PreTournament.Lose}}</v-flex>
                <v-flex xs2>{{match.PreTournament.Point}}</v-flex>
            </v-layout>

            <v-layout v-if="match.HomeRateTournament">
                <v-flex xs4>{{'Home Rate'}}</v-flex>
                <v-flex xs2>{{match.HomeRateTournament.JustWinRate}}%</v-flex>
                <v-flex xs2>{{match.HomeRateTournament.NoLoseRate}}%</v-flex>
                <v-flex xs2>{{match.HomeRateTournament.NoWinRate}}%</v-flex>
                <v-flex xs2>{{match.HomeRateTournament.JustLoseRate}}%</v-flex>
            </v-layout>

            <v-layout v-if="match.AwayRateTournament">
                <v-flex xs4>{{'Away Rate'}}</v-flex>
                <v-flex xs2>{{match.AwayRateTournament.JustWinRate}}%</v-flex>
                <v-flex xs2>{{match.AwayRateTournament.NoLoseRate}}%</v-flex>
                <v-flex xs2>{{match.AwayRateTournament.NoWinRate}}%</v-flex>
                <v-flex xs2>{{match.AwayRateTournament.JustLoseRate}}%</v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-btn color="info" @click="onCheckMatch(match)" :disabled="!match.Tournament_Available_Name && !match.TournamentID">Check</v-btn>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>
export default {
    async created() {
        this.$vs.loading({
            type: "sound"
        });

        const {type} = this.$route.params;
        // const matchLists = await this.$http.get("football/oncc/list/live");
        // const matchLists = await this.$http.get("football/oncc/list/past");
        const matchLists = await this.$http.get(`football/oncc/list/${type || 'live'}`);
        this.$vs.loading.close();

        // debugger;
        this.matchList = matchLists.data;
    },
    mounted(){
      debugger;
    },
    data() {
        return {
            matchList: false,
            tournament: {}
        };
    },
    methods: {
        async onCheckMatch(match) {
            const {
                Tournament_Available_Name,
                TournamentID,
                HomeTeamCName,
                AwayTeamCName
            } = match;

            const tName = Tournament_Available_Name || TournamentID;

            if (!tName) return console.error("no tournament id");
            this.$vs.loading({
                type: "sound"
            });

            const data = await this.$http.get(
                `football/oncc/tournament/${tName}`
            );
            this.$vs.loading.close();

            const dataArr = data.data["Teams"];

            let HomeTeamObj = {
                Win: 0,
                Draw: 0,
                Lose: 0,
                Point: 0
            };
            let AwayTeamObj = {
                Win: 0,
                Draw: 0,
                Lose: 0,
                Point: 0
            };

            dataArr.forEach(item => {
                if (item.TeamCName == HomeTeamCName) HomeTeamObj = item;
                if (item.TeamCName == AwayTeamCName) AwayTeamObj = item;
            });

            const NetTournament = {
                Win: parseInt(HomeTeamObj.Win || 0) - parseInt(AwayTeamObj.Win || 0),
                Draw: parseInt(HomeTeamObj.Draw || 0) - parseInt(AwayTeamObj.Draw || 0),
                Lose: parseInt(HomeTeamObj.Lose || 0) - parseInt(AwayTeamObj.Lose || 0),
                Point: parseInt(HomeTeamObj.Point || 0) - parseInt(AwayTeamObj.Point || 0)
            };

            const PreTournament = {
                Win: (NetTournament.Win || 0) > 0 ? "H" : "A",
                Draw: (NetTournament.Draw || 0) > 0 ? "H" : "A",
                Lose: (NetTournament.Lose || 0) > 0 ? "A" : "H",
                Point: (NetTournament.Point || 0) > 0 ? "H" : "A"
            };

            HomeTeamObj.Total =
                parseInt(HomeTeamObj.Win) +
                parseInt(HomeTeamObj.Draw) +
                parseInt(HomeTeamObj.Lose);
            const HomeRateTournament = {
                JustWinRate: (
                    (parseInt(HomeTeamObj.Win) / HomeTeamObj.Total) *
                    100
                ).toFixed(0),
                NoLoseRate: (
                    ((parseInt(HomeTeamObj.Win) + parseInt(HomeTeamObj.Draw)) /
                        HomeTeamObj.Total) *
                    100
                ).toFixed(0),
                NoWinRate: (
                    ((parseInt(HomeTeamObj.Lose) + parseInt(HomeTeamObj.Draw)) /
                        HomeTeamObj.Total) *
                    100
                ).toFixed(0),
                JustLoseRate: (
                    (parseInt(HomeTeamObj.Lose) / HomeTeamObj.Total) *
                    100
                ).toFixed(0)
            };

            AwayTeamObj.Total =
                parseInt(AwayTeamObj.Win) +
                parseInt(AwayTeamObj.Draw) +
                parseInt(AwayTeamObj.Lose);
            const AwayRateTournament = {
                JustWinRate: (
                    (parseInt(AwayTeamObj.Win) / AwayTeamObj.Total) *
                    100
                ).toFixed(0),
                NoLoseRate: (
                    ((parseInt(AwayTeamObj.Win) + parseInt(AwayTeamObj.Draw)) /
                        AwayTeamObj.Total) *
                    100
                ).toFixed(0),
                NoWinRate: (
                    ((parseInt(AwayTeamObj.Lose) + parseInt(AwayTeamObj.Draw)) /
                        AwayTeamObj.Total) *
                    100
                ).toFixed(0),
                JustLoseRate: (
                    (parseInt(AwayTeamObj.Lose) / AwayTeamObj.Total) *
                    100
                ).toFixed(0)
            };

            this.$set(match, "HomeTournament", HomeTeamObj);
            this.$set(match, "AwayTournament", AwayTeamObj);
            this.$set(match, "NetTournament", NetTournament);
            this.$set(match, "PreTournament", PreTournament);
            this.$set(match, "HomeRateTournament", HomeRateTournament);
            this.$set(match, "AwayRateTournament", AwayRateTournament);
        }
    }
};
</script>

<style scoped>
</style>
